export function strFormat(string, ...theArgs) {
  return string.replace(/{(\d+)}/g, function(match, number) { 
    return typeof theArgs[number] != 'undefined'? theArgs[number] : match;
  });
}